module.exports = __webpack_public_path__ + "static/img/ALBERTO_MONTT.02fb887.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/video-cover/ALBERTO_MONTT.jpg
// module id = VhkR
// module chunks = 1